import { createRoot } from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { Stylesheet } from '@fluentui/merge-styles';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
// ── CSP nonce ──────────────────────────────────────────────────────
// Read the nonce from the <meta property="csp-nonce"> tag the server injected
const cspNonceMeta = document.querySelector('meta[property="csp-nonce"]');
const cspNonce = cspNonceMeta ? cspNonceMeta.content : "";

// Fluent UI v8 (merge-styles) — tell its Stylesheet to stamp every <style> it creates
Stylesheet.getInstance().setConfig({ cspSettings: { nonce: cspNonce } });

// Fluent UI v9 reads the nonce automatically from
// <meta property="csp-nonce"> in index.html — no custom renderer needed.

// Emotion (used by MUI) — create a cache that stamps nonces on <style> tags
const emotionCache = createCache({ key: "mui", nonce: cspNonce });

const domNode = document.getElementById("root");
import { router } from "./routes/router";
import { initializeIcons } from '@fluentui/react';
initializeIcons();
if (!domNode) {
  throw new Error("Failed to find the root element");
}

createRoot(domNode).render(
  <CacheProvider value={emotionCache}>
    <FluentProvider theme={webLightTheme}>
      <RouterProvider router={router} />
    </FluentProvider>
  </CacheProvider>
);